module.exports = __webpack_public_path__ + "img/brand9.08e2c84a.png";